import { useEffect, useMemo } from 'react'
import { ApiClientV1 } from '../api'
import { useEventBusContext } from './context'
import { ApiClientInitOptions } from './types'

/**
 * Creates and returns a new ApiClient instance with the provided options.
 *
 * @param auth Required. An authentication object for the current user.
 * @param platformApiDomain Required. The Platform API URL for the environment.
 * @param service Optional. A service name to pass in API requests.
 */
export const useApiClientInit = ({
  auth,
  platformApiDomain,
  service,
}: ApiClientInitOptions) => {
  const eventBus = useEventBusContext()

  const apiClient = useMemo(
    () => new ApiClientV1({ auth, platformApiDomain, service, eventBus }),
    [auth, platformApiDomain, service, eventBus],
  )

  window.apiClient = apiClient

  useEffect(() => {
    if (eventBus) eventBus.emit({ topic: 'core:authReady:v1', payload: auth })
  }, [auth, eventBus])

  return apiClient
}
